/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Faceta API
 * API мультитенантного admin-движка Faceta. Спека генерируется из типов Go и является контрактом для фронтенда.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuthImpersonateHeaders,
  AuthLoginHeaders,
  AuthLogoutHeaders,
  AuthRefreshHeaders,
  AuthStopImpersonationHeaders,
  ErrorModel,
  LoginInputBody,
  SessionBody,
  UserBody
} from '../model';

import { facetaFetch } from '../../http';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type authStopImpersonationResponse200 = {
  data: SessionBody
  status: 200
}

export type authStopImpersonationResponse401 = {
  data: ErrorModel
  status: 401
}

export type authStopImpersonationResponse409 = {
  data: ErrorModel
  status: 409
}

export type authStopImpersonationResponse422 = {
  data: ErrorModel
  status: 422
}

export type authStopImpersonationResponse500 = {
  data: ErrorModel
  status: 500
}

export type authStopImpersonationResponseSuccess = (authStopImpersonationResponse200) & {
  headers: Headers;
};
export type authStopImpersonationResponseError = (authStopImpersonationResponse401 | authStopImpersonationResponse409 | authStopImpersonationResponse422 | authStopImpersonationResponse500) & {
  headers: Headers;
};

export type authStopImpersonationResponse = (authStopImpersonationResponseSuccess | authStopImpersonationResponseError)

export const getAuthStopImpersonationUrl = () => {




  return `/auth/impersonate`
}

/**
 * Закрывает сеанс поддержки и открывает новый — от имени того, кто заходил.
 * @summary Вернуться в свою учётную запись
 */
export const authStopImpersonation = async (headers?: AuthStopImpersonationHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<authStopImpersonationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<authStopImpersonationResponse>(getAuthStopImpersonationUrl(),
  {
    ...options,
    method: 'DELETE',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getAuthStopImpersonationQueryKey = () => {
    return [
    'DELETE', `/auth/impersonate`
    ] as const;
    }


export const getAuthStopImpersonationQueryOptions = <TData = Awaited<ReturnType<typeof authStopImpersonation>>, TError = ErrorModel>(headers?: AuthStopImpersonationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthStopImpersonationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authStopImpersonation>>> = ({ signal }) => authStopImpersonation(headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthStopImpersonationQueryResult = NonNullable<Awaited<ReturnType<typeof authStopImpersonation>>>
export type AuthStopImpersonationQueryError = ErrorModel


export function useAuthStopImpersonation<TData = Awaited<ReturnType<typeof authStopImpersonation>>, TError = ErrorModel>(
 headers: undefined |  AuthStopImpersonationHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authStopImpersonation>>,
          TError,
          Awaited<ReturnType<typeof authStopImpersonation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthStopImpersonation<TData = Awaited<ReturnType<typeof authStopImpersonation>>, TError = ErrorModel>(
 headers?: AuthStopImpersonationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authStopImpersonation>>,
          TError,
          Awaited<ReturnType<typeof authStopImpersonation>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthStopImpersonation<TData = Awaited<ReturnType<typeof authStopImpersonation>>, TError = ErrorModel>(
 headers?: AuthStopImpersonationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вернуться в свою учётную запись
 */

export function useAuthStopImpersonation<TData = Awaited<ReturnType<typeof authStopImpersonation>>, TError = ErrorModel>(
 headers?: AuthStopImpersonationHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authStopImpersonation>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthStopImpersonationQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authImpersonateResponse200 = {
  data: SessionBody
  status: 200
}

export type authImpersonateResponse401 = {
  data: ErrorModel
  status: 401
}

export type authImpersonateResponse403 = {
  data: ErrorModel
  status: 403
}

export type authImpersonateResponse404 = {
  data: ErrorModel
  status: 404
}

export type authImpersonateResponse409 = {
  data: ErrorModel
  status: 409
}

export type authImpersonateResponse422 = {
  data: ErrorModel
  status: 422
}

export type authImpersonateResponse500 = {
  data: ErrorModel
  status: 500
}

export type authImpersonateResponseSuccess = (authImpersonateResponse200) & {
  headers: Headers;
};
export type authImpersonateResponseError = (authImpersonateResponse401 | authImpersonateResponse403 | authImpersonateResponse404 | authImpersonateResponse409 | authImpersonateResponse422 | authImpersonateResponse500) & {
  headers: Headers;
};

export type authImpersonateResponse = (authImpersonateResponseSuccess | authImpersonateResponseError)

export const getAuthImpersonateUrl = (userId: string,) => {




  return `/auth/impersonate/${userId}`
}

/**
 * Только для владельца платформы. Открывает новый сеанс от имени клиента и запоминает, кто под него зашёл: без этого действия поддержки в журнале неотличимы от действий самого клиента. Права владельца платформы при этом не действуют — поддержка смотрит на систему глазами клиента, иначе «зайти посмотреть» превращается в полный доступ ко всему.
 * @summary Войти от имени пользователя
 */
export const authImpersonate = async (userId: string,
    headers?: AuthImpersonateHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<authImpersonateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<authImpersonateResponse>(getAuthImpersonateUrl(userId),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getAuthImpersonateQueryKey = (userId: string,) => {
    return [
    'POST', `/auth/impersonate/${userId}`
    ] as const;
    }


export const getAuthImpersonateQueryOptions = <TData = Awaited<ReturnType<typeof authImpersonate>>, TError = ErrorModel>(userId: string,
    headers?: AuthImpersonateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthImpersonateQueryKey(userId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authImpersonate>>> = ({ signal }) => authImpersonate(userId,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: userId !== null && userId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthImpersonateQueryResult = NonNullable<Awaited<ReturnType<typeof authImpersonate>>>
export type AuthImpersonateQueryError = ErrorModel


export function useAuthImpersonate<TData = Awaited<ReturnType<typeof authImpersonate>>, TError = ErrorModel>(
 userId: string,
    headers: undefined |  AuthImpersonateHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authImpersonate>>,
          TError,
          Awaited<ReturnType<typeof authImpersonate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthImpersonate<TData = Awaited<ReturnType<typeof authImpersonate>>, TError = ErrorModel>(
 userId: string,
    headers?: AuthImpersonateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authImpersonate>>,
          TError,
          Awaited<ReturnType<typeof authImpersonate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthImpersonate<TData = Awaited<ReturnType<typeof authImpersonate>>, TError = ErrorModel>(
 userId: string,
    headers?: AuthImpersonateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Войти от имени пользователя
 */

export function useAuthImpersonate<TData = Awaited<ReturnType<typeof authImpersonate>>, TError = ErrorModel>(
 userId: string,
    headers?: AuthImpersonateHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authImpersonate>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthImpersonateQueryOptions(userId,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authLoginResponse200 = {
  data: SessionBody
  status: 200
}

export type authLoginResponse401 = {
  data: ErrorModel
  status: 401
}

export type authLoginResponse422 = {
  data: ErrorModel
  status: 422
}

export type authLoginResponse500 = {
  data: ErrorModel
  status: 500
}

export type authLoginResponseSuccess = (authLoginResponse200) & {
  headers: Headers;
};
export type authLoginResponseError = (authLoginResponse401 | authLoginResponse422 | authLoginResponse500) & {
  headers: Headers;
};

export type authLoginResponse = (authLoginResponseSuccess | authLoginResponseError)

export const getAuthLoginUrl = () => {




  return `/auth/login`
}

/**
 * Отдаёт токен доступа в теле и токен обновления в cookie с флагом HttpOnly. Токен доступа хранить в памяти вкладки: положенный в localStorage, он доступен любому постороннему скрипту на странице.
 * @summary Вход по почте и паролю
 */
export const authLogin = async (loginInputBody: NonReadonly<LoginInputBody>,
    headers?: AuthLoginHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<authLoginResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<authLoginResponse>(getAuthLoginUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json',...headers, ...getHeaders(options?.headers) },
    body: JSON.stringify(loginInputBody)
  }
);}





export const getAuthLoginQueryKey = (loginInputBody?: NonReadonly<LoginInputBody>,) => {
    return [
    'POST', `/auth/login`, loginInputBody
    ] as const;
    }


export const getAuthLoginQueryOptions = <TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(loginInputBody: NonReadonly<LoginInputBody>,
    headers?: AuthLoginHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthLoginQueryKey(loginInputBody);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authLogin>>> = ({ signal }) => authLogin(loginInputBody,headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthLoginQueryResult = NonNullable<Awaited<ReturnType<typeof authLogin>>>
export type AuthLoginQueryError = ErrorModel


export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>,
    headers: undefined |  AuthLoginHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogin>>,
          TError,
          Awaited<ReturnType<typeof authLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>,
    headers?: AuthLoginHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogin>>,
          TError,
          Awaited<ReturnType<typeof authLogin>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>,
    headers?: AuthLoginHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Вход по почте и паролю
 */

export function useAuthLogin<TData = Awaited<ReturnType<typeof authLogin>>, TError = ErrorModel>(
 loginInputBody: NonReadonly<LoginInputBody>,
    headers?: AuthLoginHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogin>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthLoginQueryOptions(loginInputBody,headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authLogoutResponse204 = {
  data: void
  status: 204
}

export type authLogoutResponseDefault = {
  data: ErrorModel
  status: Exclude<HTTPStatusCodes, 204>
}

export type authLogoutResponseSuccess = (authLogoutResponse204) & {
  headers: Headers;
};
export type authLogoutResponseError = (authLogoutResponseDefault) & {
  headers: Headers;
};

export type authLogoutResponse = (authLogoutResponseSuccess | authLogoutResponseError)

export const getAuthLogoutUrl = () => {




  return `/auth/logout`
}

/**
 * Закрывает текущий сеанс и гасит cookie. Повторный выход тоже отвечает 204.
 * @summary Выйти
 */
export const authLogout = async (headers?: AuthLogoutHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<authLogoutResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<authLogoutResponse>(getAuthLogoutUrl(),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getAuthLogoutQueryKey = () => {
    return [
    'POST', `/auth/logout`
    ] as const;
    }


export const getAuthLogoutQueryOptions = <TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(headers?: AuthLogoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthLogoutQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authLogout>>> = ({ signal }) => authLogout(headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof authLogout>>>
export type AuthLogoutQueryError = ErrorModel


export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
 headers: undefined |  AuthLogoutHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogout>>,
          TError,
          Awaited<ReturnType<typeof authLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
 headers?: AuthLogoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authLogout>>,
          TError,
          Awaited<ReturnType<typeof authLogout>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
 headers?: AuthLogoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Выйти
 */

export function useAuthLogout<TData = Awaited<ReturnType<typeof authLogout>>, TError = ErrorModel>(
 headers?: AuthLogoutHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authLogout>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthLogoutQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authMeResponse200 = {
  data: UserBody
  status: 200
}

export type authMeResponse401 = {
  data: ErrorModel
  status: 401
}

export type authMeResponse500 = {
  data: ErrorModel
  status: 500
}

export type authMeResponseSuccess = (authMeResponse200) & {
  headers: Headers;
};
export type authMeResponseError = (authMeResponse401 | authMeResponse500) & {
  headers: Headers;
};

export type authMeResponse = (authMeResponseSuccess | authMeResponseError)

export const getAuthMeUrl = () => {




  return `/auth/me`
}

/**
 * Проверяет токен доступа и возвращает пользователя. Фронтенд зовёт её при загрузке, чтобы понять, жив ли сеанс.
 * @summary Кто выполняет запрос
 */
export const authMe = async ( options?: Parameters<typeof facetaFetch>[1]): Promise<authMeResponse> => {

  return facetaFetch<authMeResponse>(getAuthMeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAuthMeQueryKey = () => {
    return [
    `/auth/me`
    ] as const;
    }


export const getAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthMeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authMe>>> = ({ signal }) => authMe({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof authMe>>>
export type AuthMeQueryError = ErrorModel


export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authMe>>,
          TError,
          Awaited<ReturnType<typeof authMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Кто выполняет запрос
 */

export function useAuthMe<TData = Awaited<ReturnType<typeof authMe>>, TError = ErrorModel>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authMe>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type authRefreshResponse200 = {
  data: SessionBody
  status: 200
}

export type authRefreshResponse401 = {
  data: ErrorModel
  status: 401
}

export type authRefreshResponse422 = {
  data: ErrorModel
  status: 422
}

export type authRefreshResponse500 = {
  data: ErrorModel
  status: 500
}

export type authRefreshResponseSuccess = (authRefreshResponse200) & {
  headers: Headers;
};
export type authRefreshResponseError = (authRefreshResponse401 | authRefreshResponse422 | authRefreshResponse500) & {
  headers: Headers;
};

export type authRefreshResponse = (authRefreshResponseSuccess | authRefreshResponseError)

export const getAuthRefreshUrl = () => {




  return `/auth/refresh`
}

/**
 * Меняет токен обновления из cookie на новую пару. Прежний токен при этом перестаёт работать: предъявленный повторно, он считается украденным, и все сеансы пользователя закрываются.
 * @summary Обновить доступ
 */
export const authRefresh = async (headers?: AuthRefreshHeaders, options?: Parameters<typeof facetaFetch>[1]): Promise<authRefreshResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return facetaFetch<authRefreshResponse>(getAuthRefreshUrl(),
  {
    ...options,
    method: 'POST',
    headers: { ...headers, ...getHeaders(options?.headers) }

  }
);}





export const getAuthRefreshQueryKey = () => {
    return [
    'POST', `/auth/refresh`
    ] as const;
    }


export const getAuthRefreshQueryOptions = <TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(headers?: AuthRefreshHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthRefreshQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof authRefresh>>> = ({ signal }) => authRefresh(headers, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AuthRefreshQueryResult = NonNullable<Awaited<ReturnType<typeof authRefresh>>>
export type AuthRefreshQueryError = ErrorModel


export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
 headers: undefined |  AuthRefreshHeaders, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRefresh>>,
          TError,
          Awaited<ReturnType<typeof authRefresh>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
 headers?: AuthRefreshHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authRefresh>>,
          TError,
          Awaited<ReturnType<typeof authRefresh>>
        > , 'initialData'
      >, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
 headers?: AuthRefreshHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Обновить доступ
 */

export function useAuthRefresh<TData = Awaited<ReturnType<typeof authRefresh>>, TError = ErrorModel>(
 headers?: AuthRefreshHeaders, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authRefresh>>, TError, TData>>, request?: SecondParameter<typeof facetaFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAuthRefreshQueryOptions(headers,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






